import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import { connect } from 'react-redux'
import { getFlatNavItems } from 'selectors/navigationSelectors'
import { getOfferTypesContent } from './constants'
import CategoryTile from 'LuxKit/CategoryTile'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import useLocalizedOfferTypesList from 'hooks/useLocalizedOfferTypesList'

interface MappedProps {
  navItems: Array<App.NavItem>
}

interface Props {
  disableActionButton?: boolean
}

function OfferTypesCarousel({ navItems, disableActionButton = false }: MappedProps & Props) {
  const intl = useIntl()
  const localizedOfferTypes = useLocalizedOfferTypesList()
  const content = useMemo(() => getOfferTypesContent(navItems, localizedOfferTypes).filter(offerContent => offerContent.show), [navItems, localizedOfferTypes])

  const viewOffersLabel = intl.formatMessage({
    id: 'UHQzHhgylLLmmGuagMu_',
    defaultMessage: 'View offers',
  })

  return (
    <FullWidthCarousel
      itemsPerArrow={6}
      snap="start"
      gap={12}
      width={rem(180)}
    >
      {content.map((offerType) => (
        <CategoryTile
          key={offerType.to}
          heading={offerType.title}
          subHeading={offerType.description}
          align="top"
          callToAction={disableActionButton ? undefined : viewOffersLabel}
          to={disableActionButton ? undefined : offerType.to}
          image={offerType.image}
          imageLoading="lazy"
        />
      ))}
    </FullWidthCarousel>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    navItems: getFlatNavItems(state),
  }
}

export default connect(mapStateToProps)(OfferTypesCarousel)
